/* 
  Class: User
  Description: This class contain all user fields.
*/

export default class User {
  constructor(first_name, middle_name, last_name, email, password, avatar) {
    this.first_name = first_name;
    this.middle_name = middle_name;
    this.last_name = last_name;
    this.email = email;
    this.password = password;
    this.avatar = avatar;
  }
}